<template>
  <v-menu ref="timePickerMenu" v-model="timePickerMenu" :close-on-content-click="false" transition="scale-transition" offset-y nudge-top="40" min-width="auto">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field :value="value" v-on="on" outlined :label="label" dense readonly v-bind="attrs" :prefix="prefix" :rounded="rounded" :filled="filled" append-icon="mdi-clock-time-four-outline"/>
    </template>
    <v-time-picker header-color="rgba( 241, 95, 49, 0.24)" color="primary"  class="text-primary" :value="value" @input="handleInput($event)" @change="handleInput" :format="format" />
  </v-menu>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    prefix: { type: String },
    label: { type: String },
    rounded: { type: Boolean, default: false },
    filled: { type: Boolean, default: false },
    format: { type: String, default: "ampm" },
  },
  data() {
    return {
      timePicker: null,
      time: null,
      timePickerMenu: false,
    };
  },
  methods: {
    handleInput(event) {
      this.timePickerMenu = false;
      this.$emit("input", event);
      this.$refs.timePickerMenu.save(event);
    },
  },
};
</script>
